/** indiv 流程：tab=login|register；其它场景仍用 type=login|register */
export const AUTH_TAB_QUERY_KEY = 'tab';

export function isIndivAuthFlow(query = {}) {
  return String(query.from) === 'indiv';
}

/** 登录失效等场景跳转登录页，保留 from=indiv */
export function loginRedirectRoute(query = {}) {
  if (isIndivAuthFlow(query)) {
    return { path: '/login', query: { from: 'indiv' } };
  }
  return { path: '/login' };
}

export function tabFromQuery(query = {}) {
  if (isIndivAuthFlow(query)) {
    const tab = query[AUTH_TAB_QUERY_KEY];
    if (tab === 'register' || tab === 'login') return tab;
    return 'login';
  }
  const type = query.type;
  if (type === 'register' || type === 'login') return type;
  return 'login';
}

/** 仅 indiv：登录/注册成功后从 query 去掉 tab */
export function queryWithoutIndivAuthTab(query = {}) {
  if (!isIndivAuthFlow(query)) return { ...query };
  const q = { ...query };
  delete q[AUTH_TAB_QUERY_KEY];
  return q;
}

/** 非 indiv 登录回跳：去掉 from=indiv（及 indiv 专用 tab），避免沿用历史 path */
export function stripFromIndivFromHref(href) {
  if (!href || typeof href !== 'string') return href;
  const hashIdx = href.indexOf('#');
  const hash = hashIdx >= 0 ? href.slice(hashIdx) : '';
  const beforeHash = hashIdx >= 0 ? href.slice(0, hashIdx) : href;
  const qIdx = beforeHash.indexOf('?');
  if (qIdx < 0) return href;
  const pathname = beforeHash.slice(0, qIdx);
  const params = new URLSearchParams(beforeHash.slice(qIdx + 1));
  if (params.get('from') !== 'indiv') return href;
  params.delete('from');
  params.delete(AUTH_TAB_QUERY_KEY);
  const search = params.toString();
  return pathname + (search ? `?${search}` : '') + hash;
}

/** 仅 indiv 回跳地址：去掉 tab，避免与 type=9 等业务参数混淆 */
export function stripIndivAuthTabFromHref(href) {
  if (!href || typeof href !== 'string') return href;
  const hashIdx = href.indexOf('#');
  const hash = hashIdx >= 0 ? href.slice(hashIdx) : '';
  const beforeHash = hashIdx >= 0 ? href.slice(0, hashIdx) : href;
  const qIdx = beforeHash.indexOf('?');
  if (qIdx < 0) return href;
  const pathname = beforeHash.slice(0, qIdx);
  const params = new URLSearchParams(beforeHash.slice(qIdx + 1));
  if (params.get('from') !== 'indiv') return href;
  params.delete(AUTH_TAB_QUERY_KEY);
  const search = params.toString();
  return pathname + (search ? `?${search}` : '') + hash;
}



// WEBPACK FOOTER //
// ./src/utils/authTabQuery.js